import { ConstraintRule } from '../constraint-rule';
import {
  BookingParams,
  BookingPosition,
  ConstraintSummary,
  StockTargetType,
} from '../../types';

/**
 * Blockt Buchungen, bei denen Quelle und Ziel dasselbe Lager sind (gleicher Typ und gleiche Id).
 */
export class RuleSourceTargetDifferent extends ConstraintRule {
  /**
   * Greift nur, wenn Quell- und Zieltyp übereinstimmen.
   * @param position Zu prüfende Buchungsposition (nicht verwendet).
   * @param params Buchungsparameter, aus deren Kontext Quell- und Zieltyp gelesen werden.
   * @returns True, wenn Quell- und Zieltyp gleich sind.
   */
  public async needsCheck(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<boolean> {
    const { booking } = params.context;
    // CAR, MACHINE und BUFFERSTOCK sind auch immer Teil von StockTargetType
    return booking.sourceType as unknown as StockTargetType === booking.targetType;
  }

  /**
   * Prüft, ob Quell- und Ziel-Id verschieden sind.
   * @param position Zu prüfende Buchungsposition (nicht verwendet).
   * @param params Buchungsparameter, aus deren Kontext Quell- und Ziel-Id gelesen werden.
   * @returns Nicht erfüllt, wenn Quell- und Ziel-Id gleich sind, sonst erfüllt.
   */
  public async check(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<ConstraintSummary> {
    const { booking } = params.context;
    if (booking.sourceId === booking.targetId) {
      return this.unsatisfied(
        $localize`Quelle = Ziel ist verboten`
      );
    }
    return this.satisfied();
  }
}
